import { useAutocompleteSource } from '@eas/common-web';
import { DictActTypeAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useActTypes() {
  return useAutocompleteSource<DictActTypeAutocomplete>({
    url: `${EvidenceApiUrl.DICT_ACT_TYPE}/autocomplete`,
  });
}
